module.exports = __webpack_public_path__ + "img/customer-service.d5462faa.png";